import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { StatoRiparazione } from 'src/app/models/stato-riparazione';
import { StatoRiparazioneService } from 'src/app/services/stato-riparazione.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditStatoRiparazioneComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'stati-riparazione',
  templateUrl: './stati-riparazione.component.html',
  styleUrls: ['./stati-riparazione.component.scss']
})
export class StatiRiparazioneComponent implements OnInit {


  headingText: string = 'Stati riparazione';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
  ];
  constructor(public statoRiparazioneService: StatoRiparazioneService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<StatiRiparazioneComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona uno stato di riparazione';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (statoRiparazione: StatoRiparazione) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare la riparazione in forma specifica ${statoRiparazione.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.statoRiparazioneService.delete(statoRiparazione);
          this.toast.success('Riparazione in forma specifica eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione riparazione in forma specifica fallita.", "Errore!");
    }
  }



  editFunction = async (statoRiparazione: StatoRiparazione) => {
    try {
      let dialogRef = this.dialog.open(EditStatoRiparazioneComponent, { data: statoRiparazione });
      dialogRef.afterClosed().subscribe(async (data: StatoRiparazione) => {
        if (data) {

          Object.assign(statoRiparazione, data);

          await this.statoRiparazioneService.edit(statoRiparazione);

          this.toast.success('Riparazione in forma specifica modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica riparazione in forma specifica fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditStatoRiparazioneComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(statoRiparazione?: StatoRiparazione) {
    if (statoRiparazione) {
      try {
        await this.statoRiparazioneService.create(statoRiparazione)
        this.toast.success('Riparazione in forma specifica creata!')
      }
      catch (e) {
        this.toast.error('Creazione riparazione in forma specifica fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
